/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { LegaleseComponent } from './legalese/legalese.component';
import {
	LoadingBlockerDirective,
	LoadingBlockerSpinnerComponent,
	LoadingBlockerSuccessComponent,
	LoadingBlockerFailureComponent,
} from './loading-blocker';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [CommonModule],
	declarations: [
		LegaleseComponent,
		LoadingBlockerDirective,
		LoadingBlockerSpinnerComponent,
		LoadingBlockerSuccessComponent,
		LoadingBlockerFailureComponent,
	],
	exports: [
		LegaleseComponent,
		LoadingBlockerDirective,
		LoadingBlockerSpinnerComponent,
		LoadingBlockerSuccessComponent,
		LoadingBlockerFailureComponent,
	],
	providers: [],
})
export class SharedUtilityComponentsModule {}
